import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Image } from 'rebass';
import { Dropdown } from 'semantic-ui-react';
import ReactGA from 'react-ga';

import { SPACE } from 'Components/Theme';
import { Text, PrintBox } from 'Components/Base';
import { Header } from 'Components/MockExam/Subcomponents';
import { getBanner, isBannerCTAEnabled } from 'Domain';

import { Banner } from '../../Components';

import { ExamStat, ExamResultPanel } from './components';

export default class Overview extends Component {
  static propTypes = {
    subjectName: PropTypes.string,
    myMockExamResult: PropTypes.shape({
      score: PropTypes.number,
      rank: PropTypes.number,
    }),
    mockExamResult: PropTypes.shape({
      fullScore: PropTypes.number,
      averageScore: PropTypes.number,
      sdScore: PropTypes.number,
      maximumScore: PropTypes.number,
      minimumScore: PropTypes.number,
      examAttendee: PropTypes.number,
      histogram: PropTypes.shape({
        percent: PropTypes.arrayOf(PropTypes.number),
        count: PropTypes.arrayOf(PropTypes.number),
        range: PropTypes.shape({
          max: PropTypes.number,
          min: PropTypes.number,
        }),
      }),
    }),
    officialHistory: PropTypes.arrayOf(
      PropTypes.shape({
        examId: PropTypes.string,
        examHistoryTitle: PropTypes.string,
      }),
    ),
    scoreVariant: PropTypes.string,
  };

  static defaultProps = {
    myMockExamResult: {
      score: 12,
    },
    mockExamResult: {
      fullScore: 20,
      averageScore: 10,
      sdScore: 2,
      maximumScore: 19,
      minimumScore: 3,
      examAttendee: 8624,
    },
  };

  initHistoryExam = officialHistory => {
    if (officialHistory && officialHistory.length > 0) {
      return officialHistory[0];
    } else {
      return undefined;
    }
  };

  state = { historyExam: this.initHistoryExam(this.props.officialHistory) };

  handleHistoryDDLChange = (e, data) => {
    const { officialHistory } = this.props;
    const historyExamId = data.value;
    const historyExam = officialHistory.find(exam => exam.examId === historyExamId);
    this.setState({
      historyExam: historyExam,
    });
  };

  handleBannerClick = (event, subjectCode, subjectName) => {
    try {
      ReactGA.event({
        category: 'CAMPAIGN_MF_2562-01',
        action: 'Tab1 Banner Click',
        label: `${subjectName}:${subjectCode}`,
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    const { href, search } = event.currentTarget;
  };

  renderMFBanner = () => {
    const { subjectCode, subjectName } = this.props;
    const { image: bannerImage, link: bannerLink } = getBanner(subjectCode, 'tab1');

    return isBannerCTAEnabled && bannerImage && bannerLink ? (
      <Banner
        link={bannerLink}
        imageSrc={bannerImage}
        subjectName={subjectName}
        onBannerClick={event => this.handleBannerClick(event, subjectCode, subjectName)}
      />
    ) : null;
  };

  render() {
    const {
      subjectName,
      myMockExamResult,
      mockExamResult,
      officialHistory,
      mockExamId,
      scoreVariant,
    } = this.props;
    const { score, rank } = myMockExamResult;
    const { fullScore, averageScore } = mockExamResult;
    const { historyExam } = this.state;
    const image = scoreVariant === 'meds' ? 'medical-exam-logo.png' : 'niets-logo.png';

    return (
      <Box mt={SPACE.large}>
        <Box mb={SPACE.large}>
          <ExamResultPanel
            title="ผลคะแนนจากการสอบ TCASter Mock Exam"
            score={score}
            fullScore={fullScore}
            averageScore={averageScore}
            scoreVariant={scoreVariant}
          />
        </Box>
        {this.renderMFBanner()}
        <PrintBox before={true} after={true}>
          <Text.Title mb={SPACE.large}>เทียบคะแนนกับผู้เข้าสอบอื่น</Text.Title>
          <Header mb={SPACE.large}>1. เทียบคะแนนกับผู้เข้าสอบ TCASter Mock Exam</Header>
          <ExamStat
            mockExamId={mockExamId}
            subjectName={subjectName}
            examTitle={subjectName}
            score={score}
            rank={rank}
            chartTitle={`1.1 กราฟแสดงช่วงคะแนนของผู้เข้าสอบ TCASter Mock วิชา ${subjectName}`}
            tableTitle={`1.2 ตารางแสดงช่วงคะแนนของผู้เข้าสอบ TCASter Mock วิชา ${subjectName}`}
            scoreVariant={scoreVariant}
          />
        </PrintBox>
        {officialHistory && officialHistory.length > 0 && (
          <Fragment>
            <Header mb={SPACE.large}>2. เทียบคะแนนกับผู้เข้าสอบจริง ปี 2557-2560</Header>
            <Flex
              alignItems={'center'}
              justifyContent={'space-between'}
              mb={SPACE.large}
              flexWrap={['wrap', 'nowrap']}
            >
              <Image src={`/images/${image}`} width={'142px'} />
              <Flex alignItems={'center'} mt={[2, 0]}>
                <Text mr={SPACE.small} fontWeight={'bold'}>
                  เลือกปีเพื่อเทียบคะแนน:
                </Text>
                <Dropdown
                  selection
                  value={historyExam.examId}
                  options={officialHistory.map(history => ({
                    text: history.examHistoryTitle,
                    value: history.examId,
                  }))}
                  placeholder="กรุณาเลือกรอบการสอบ"
                  onChange={this.handleHistoryDDLChange}
                />
              </Flex>
            </Flex>
            {historyExam && (
              <ExamStat
                mockExamId={historyExam.examId}
                subjectName={historyExam.examHistoryTitle}
                examTitle={historyExam.examHistoryTitle}
                color={'blue'}
                score={score}
                chartTitle={`2.1 กราฟแสดงช่วงคะแนนของผู้เข้าสอบ วิชา ${historyExam.examHistoryTitle}`}
                tableTitle={`2.2 ตารางแสดงช่วงคะแนนของผู้เข้าสอบ วิชา ${historyExam.examHistoryTitle}`}
                scoreVariant={scoreVariant}
              />
            )}
          </Fragment>
        )}
      </Box>
    );
  }
}
